
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "SliderImagesBlock",

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 1,
        slidesPerGroup: 1,

        breakpoints: {
          1200: {
            spaceBetween: 20,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          860: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          640: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
          },
        },
        navigation: {
          prevEl: '.slider-images-block__button-navition--prev',
          nextEl: '.slider-images-block__button-navition--next'
        },
      },
    }
  },

  components: {
    Swiper,
    SwiperSlide
  },

  methods: {
    openImages: function (index) {
      this.$store.commit("pop-up-images/setOpen", {
        images: (this.values.items || []).map((t) => t.image),
        activeIndex: index
      })
    }
  }
})
